import { fetchMaterialList } from '../api/material'

export default {
  data() {
    return {
      loading: false,
      materialList: [], // 素材列表
      pagination: {
        page: 1,
        pageSize: 48,
        total: 0,
        hasMore: true
      },
      searchValue: ''
    }
  },
  methods: {
    /**
     * @description: 获取素材列表
     * @param {boolean} refresh 是否为刷新
     * @return {promise}
     */    
     async getMaterialList(refresh = false) {
      try {
        this.loading = true
        if(refresh) {
          this.pagination = {
            page: 1,
            pageSize: 48,
            total: 0,
            hasMore: true
          }
          this.materialList = []
        }
        // 没有更多
        if(!this.pagination.hasMore) return

        const res = await fetchMaterialList({
          page: this.pagination.page,
          size: this.pagination.pageSize,
          keyword: this.searchValue
        })

        if(res.stat !== 1) { 
          this.pagination.hasMore = false 
          return
        }

        this.materialList = this.materialList.concat(res.data.list)

        this.pagination.page++
        this.pagination.total = res.data.total

        if(this.materialList.length >= res.data.total) {
          this.pagination.hasMore = false
        }
      } catch (error) {
        // 兼容授权报错
        this.pagination.hasMore = false
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    /**
     * @description: 加载更多
     * @return {void}
     */    
     handleMore() {
      if(!this.pagination.hasMore || this.loading) {
        return
      }

      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      const clientHeight = document.documentElement.clientHeight || document.body.clientHeight
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight

      if(scrollTop + clientHeight + 200 >= scrollHeight) {
        this.getMaterialList()
      }
    },
  }
}



// WEBPACK FOOTER //
// ./pc/yiqijian-video/mixins/material-extends.js